import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "max-w-[200px] truncate" }
const _hoisted_3 = ["title", "onClick"]
const _hoisted_4 = { class: "max-w-[200px] truncate" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "truncate" }

import { UiDropdownV2 as UiDropdown, UiMenuBaseTrigger } from '@klausapp/ui-kit'
import { Modes } from '@klausapp/ui-kit/components/UiDropdownV2/types'
import { ref, computed } from 'vue'
import { useWorkspaceList } from '@/composables/useWorkspaceList'
import type { SessionWorkspace } from '@/types/session'
import type { WorkspaceItem } from '@/types/workspace'


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkspaceSelection',
  props: {
    fadedLabel: { type: Boolean },
    shadowLabel: { type: Boolean },
    activeWorkspace: {}
  },
  emits: ["switch-workspace"],
  setup(__props: any, { expose: __expose }) {





const tippyRef = ref<any>()

const [workspaces] = useWorkspaceList()

const options = computed(() => {
  return workspaces.value.map((workspace) => ({
    id: workspace.id,
    label: workspace.name,
    value: workspace.id,
    color: workspace.color,
  }))
})

__expose({
  tippyRef,
})

return (_ctx: any,_cache: any) => {
  return (_ctx.activeWorkspace?.id)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_unref(workspaces).length === 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              title: _ctx.activeWorkspace.name,
              class: _normalizeClass(["relative flex h-5 w-min max-w-full cursor-pointer items-center gap-2 rounded-[88px] text-xs font-semibold", [
        _ctx.fadedLabel ? 'text-gray-50 hover:bg-[--sidebar-link-background-hover]' : 'hover:bg-gray-20 text-gray-600',
        _ctx.shadowLabel ? 'bg-white pl-2 pr-3 shadow-sm' : '-left-1 pl-1 pr-2',
      ]]),
              "data-testid": "workspace-list-trigger"
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["shrink-0 rounded-full", [
          _ctx.fadedLabel ? 'border-subnav-background' : 'border-white',
          _ctx.shadowLabel ? 'h-2 w-2' : 'h-3 w-3 border-2 shadow-sm',
        ]]),
                style: _normalizeStyle({ backgroundColor: _ctx.activeWorkspace.color })
              }, null, 6 /* CLASS, STYLE */),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.activeWorkspace.name), 1 /* TEXT */)
            ], 10 /* CLASS, PROPS */, _hoisted_1))
          : (_unref(workspaces))
            ? (_openBlock(), _createBlock(_unref(UiDropdown), {
                key: 1,
                "data-testid": "workspace-selection",
                "model-value": [_ctx.activeWorkspace.id],
                mode: _unref(Modes).Single,
                options: options.value,
                "search-placeholder": _ctx.$t('universal.search'),
                "no-results-text": _ctx.$t('pickers.workspaces.no_results'),
                "has-search": _unref(workspaces).length > 8,
                "prop-to-check": "id",
                label: "label",
                "close-on-select": "",
                "filter-results": "",
                "max-width": 480,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('switch-workspace', $event)))
              }, {
                trigger: _withCtx(({ selectedOptions }) => [
                  _createVNode(_unref(UiMenuBaseTrigger), null, {
                    default: _withCtx(({ openMenu }) => [
                      _createElementVNode("div", {
                        title: _ctx.activeWorkspace.name,
                        class: _normalizeClass(["relative flex h-5 w-min max-w-full cursor-pointer items-center gap-2 rounded-[88px] text-xs font-semibold", [
                _ctx.fadedLabel ? 'text-gray-50 hover:bg-[--sidebar-link-background-hover]' : 'hover:bg-gray-20',
                _ctx.shadowLabel ? 'bg-white pl-2 pr-3 shadow-sm' : '-left-1 pl-1 pr-2',
              ]]),
                        "data-testid": "workspace-list-trigger",
                        type: "button",
                        onClick: openMenu
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["shrink-0 rounded-full", [
                  _ctx.fadedLabel ? 'border-subnav-background' : 'border-white',
                  _ctx.shadowLabel ? 'h-2 w-2' : 'h-3 w-3 border-2 shadow-sm',
                ]]),
                          style: _normalizeStyle({ backgroundColor: selectedOptions[0]?.color })
                        }, null, 6 /* CLASS, STYLE */),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(selectedOptions[0]?.label), 1 /* TEXT */)
                      ], 10 /* CLASS, PROPS */, _hoisted_3)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]),
                option: _withCtx(({ option }) => [
                  _createElementVNode("div", {
                    class: "flex items-center gap-2",
                    title: option.label,
                    "data-testid": "workspace-list-item"
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["h-3 w-3 shrink-0 rounded-full border-2 border-white shadow-sm", [_ctx.fadedLabel && 'bg-border-subnav-background']]),
                      style: _normalizeStyle({ backgroundColor: option.color })
                    }, null, 6 /* CLASS, STYLE */),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(option.label), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_5)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["model-value", "mode", "options", "search-placeholder", "no-results-text", "has-search"]))
            : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    : _createCommentVNode("v-if", true)
}
}

})